import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BpService } from '../../../core/services/bp.service';
import { IBp } from '../../../core/modules/business-process/business-process.types';

@Injectable({
  providedIn: 'root',
})
export class NewRetailPlaceResolverService {
  constructor(
    private bpService: BpService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IBp> | Promise<IBp> | IBp {
    const { retailPlaceId } = route.params;

    return retailPlaceId
      ? this.bpService.start('updateRetailPlaceMessage', {
        retailPlaceId,
      }, {
        skipLocationChange: true,
      })
      : this.bpService.start('createRetailPlaceMessage', {}, {
        skipLocationChange: true,
      });
  }
}
